import React from 'react'

import IDLE_CONFIRMATION_IMAGE from '@public/assets/welcome-wizard/desktop-agent-idle-confirmation.png'
import DESKTOP_WARNING_IMAGE from '@public/assets/welcome-wizard/desktop-agent-sign-in-warning.png'

const DesktopAgentRunningStep = () => (
  <div className="max-w-[900px]">
    <h2 className="text-lg font-semibold text-black">
      Make sure Desktop Agent is running
    </h2>
    <p className="mt-3 text-base leading-[1.35] text-[#666]">
      The Desktop Agent can be turned on or off at any time. We recommend
      leaving the Desktop Agent running throughout the workday to ensure MIRA
      captures the most complete picture of your activities.
    </p>
    <h3 className="mt-4 font-semibold">1. Not Running Warning</h3>
    <p className="mt-2 pl-4 text-base text-[#666]">
      You&apos;ll see a warning when you log in to MIRA if the Desktop Agent
      isn&apos;t installed or you&apos;re not signed in.
    </p>
    <img
      alt="Desktop Agent not signed in warning"
      className="ml-4 mt-3 w-[calc(100%_-_1rem)] max-w-[850px] object-contain"
      src={DESKTOP_WARNING_IMAGE}
    />
    <h3 className="mt-5 font-semibold">2. Idle Confirmation</h3>
    <p className="mt-2 pl-4 text-base leading-[1.35] text-[#666]">
      If MIRA detects a period of inactivity, it may assume you are idle. If you
      are still working, simply:
    </p>
    <ul className="mt-1 list-disc pl-12 text-base leading-[1.35] text-[#666]">
      <li>Move your mouse, or</li>
      <li>Press any key</li>
    </ul>
    <p className="mt-1 pl-4 text-base leading-[1.35] text-[#666]">
      This signals that you are still active, and MIRA will continue tracking
      your work rather than treating the period as idle.
    </p>
    <img
      alt="Still working idle confirmation"
      className="ml-4 mt-4 w-[280px] object-contain"
      src={IDLE_CONFIRMATION_IMAGE}
    />
  </div>
)

export default DesktopAgentRunningStep
